/**
 * Class representing a collection of tenants and managing the current tenant index.
 */
class Tenants {

  /**
   * Creates an instance of the Tenants class.
   *
   * @param {Array} tenants - An array of tenants.
   * @param {number} currentTenantIndex - The index of the current tenant in the tenants array.
   */
  constructor(tenants, currentTenantIndex) {
    /**
     * @property {Array} tenants - The list of tenants.
     */
    this.tenants = tenants || [];

    /**
     * @property {number} currentTenantIndex - The index of the currently selected tenant.
     */
    this.currentTenantIndex = currentTenantIndex || 0;
  }

  /**
   * Gets the list of tenants.
   *
   * @returns {Array} The list of tenants.
   */
  get() {
    return this.tenants;
  }

  /**
   * Sets the list of tenants.
   *
   * @param {Array} tenants - The new list of tenants.
   */
  set(tenants) {
    this.tenants = tenants;
  }

  /**
   * Gets the index of the currently selected tenant.
   *
   * @returns {number} The index of the current tenant.
   */
  getCurrentIndex() {
    return this.currentTenantIndex;
  }

  /**
   * Sets the index of the current tenant.
   *
   * @param {number} index - The new index for the current tenant.
   */
  setCurrentIndex(index) {
    this.currentTenantIndex = index;
  }

  /**
   * Gets the currently selected tenant.
   *
   * @returns {*} The current tenant object or value.
   */
  getCurrent() {
    return this.get()[this.currentTenantIndex];
  }

}

export default Tenants;